module.exports = __webpack_public_path__ + "img/冷链监控系统1.23555305.png";